'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
  var action = arguments[1];

  switch (action.type) {
    case 'GET_FEIS_ADJUDICATORS_START':
      return state.setIn([action.feis_id], (0, _immutable.fromJS)({ loading: true }));

    case 'GET_FEIS_ADJUDICATORS':
      return state.setIn([action.feis_id], (0, _immutable.fromJS)(action.payload.map(function (adjudicator) {
        return adjudicator.id;
      })));

    default:
      return state;
  }
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/reducers/feiseanna/adjudicators/index.js
// module id = 693
// module chunks = 0